import React from 'react'
import './ourhistory.scss'
import { images } from "../../../utils/customFn";
const OurHistory = () => {
  // Reusable Component for each section block
  const TopicContentBlock = ({ title, children }) => (
    <div className="topicContentBlock">
      <div className="Heading">
        <h3>{title}</h3>
      </div>
      <div>{children}</div>
    </div>
  );

  return (
    <>
      <div className="LeftSide">
        {/* Main Introduction */}
        <TopicContentBlock title="Our strong past will provide you a secure future">
          <p>Back in 1904, members of the Wisconsin Retail Hardware Association gave us our start when they formed their own mutual insurance company. We’ve grown far beyond Wisconsin and the hardware industry in the years since. But we’ve always retained our core values as a mutual company.</p>
          <p>
          We’ve never forgotten our Midwest roots, either. Our true strength comes from our dedication to personalized care—something we’ve provided since our inception. We grew by leveraging knowledge in one market to branch out into similar industries.
          </p>
          <p>
          We work hard to understand our customers’ businesses—and their industries inside and out, and we work hard to get to know each individual policyholder well. Our current mix of customers is a testament to our broad knowledge. And we put that knowledge into practical use to serve you better.
          </p>
          <p>
          The foundation of our success today is based on sound practices in the past. Here’s a glimpse as to how we got here.
          </p>
          <p>
            We pride ourselves on providing individualized service to our customers. And one of the ways we do this is by using dedicated teams to serve specific industries. Over the years, departments have grown organically around our products and services.
          </p>
          <p><b>1904:</b> The Wisconsin Retail Hardware Association forms a mutual fire insurance company, named the Hardware Dealers Mutual Fire Insurance Company of Wisconsin, located in Berlin, Wisconsin. The company issues its first policy on April 9 to C.A. Dewey of Kenosha, Wisconsin, for $500 worth of property coverage. The total premium cost: $6.25.</p>
          <p><b>1912:</b> Secretary P.J. Jacobs moves the company to Stevens Point, Wisconsin.</p>
          <p><b>1914:</b> A separate insurance company is formed to write workers’ compensation insurance—the Wisconsin Hardware Limited Mutual Liability Insurance Company.</p>
          <img src={images["1912-Hrdwre-Mtl-bldg-bw.jpg"]}/>
          <p><b>1916:</b> Hardware Mutual companies begin to write auto insurance lines.</p>
          <p><b>1932:</b> The Hardware Mutual companies are licensed to write insurance in what was then all 48 states.</p>
          <p><b>1936:</b> With P.J. Jacobs’ death, his son Carl N. Jacobs assumes leadership of the company.</p>
          <p><b>1945:</b> C.N. Jacobs takes on role of president of Hardware Dealers Mutual Fire Insurance Company and Hardware Mutual Casualty Company.</p>
          <p><b>1958:</b> Sentry Life Insurance Company is born to meet the life insurance needs of policyholders.</p>
          <img src={images["1963-Strongs-sign.jpg"]}/>
          <p><b>1962:</b> The company announces a new corporate image campaign, including the name “Sentry” and the Captain John Parker minuteman statue.</p>
          <p><b>1966:</b> John Joanis elected CEO and president.</p>
          <p><b>1966:</b> Sentry acquires Dairyland Insurance Company.</p>
          <p><b>1970:</b> A merger takes place between Hardware Mutual Casualty Company and Hardware Dealers Mutual Fire Insurance Company, complete with a new name—Hardware Mutual Casualty.</p>
          <p><b>1971:</b> The company changes its name from Hardware Mutual Casualty Company to Sentry Insurance a Mutual Company (SIAMCO).</p>
          <p><b>1977:</b> “Sentry World Headquarters” office opens in Stevens Point.</p>
          <img src={images["1977-SHO-bldg-opens.jpg"]}/>
          <p><b>1982:</b> SentryWorld golf course and sports complex opens.</p>
          <p><b>1985:</b> Larry Ballard named president, CEO, and chairman of the board.</p>
          <p><b>1992:</b> SIAMCO earns A+ rating by AM Best*, a rating Sentry has earned every year since.</p>
          <p><b>1998:</b> Dale Schuh elected chairman of the board.</p>
          <p><b>1999:</b> Sentry acquires John Deere Insurance Group.</p>
          <p><b>2010:</b> Pete McPartland named president and COO.</p>
          <p><b>2013:</b> McPartland named chairman of the board.</p>
          <img src={images["Sentry-Insurance-CEOs-626x136.jpg"]}/>
          <p><b>2014:</b> Regional office opens in Montgomery, Alabama.</p>
          <p><b>2015:</b> Midwest regional offices open in Madison, Wisconsin and Milwaukee, Wisconsin.</p>
          <p><b>2015:</b> Sentry affiliates with Florists’ Mutual Insurance Company, which does business under the Hortica® brand name—now a member of the Sentry group of companies.</p>
          <p><b>2017:</b> Southeast regional office opens in Charlotte, North Carolina.</p>
          <p>Since 1904, we’ve been known for maintaining long-term customer relationships and supporting our communities. It’s who we’ve been. It’s who we are. And who we will be.</p>
        </TopicContentBlock>
      </div>
    </>
  )
}

export default OurHistory